import { ReactComponent as Boy1 } from './assets/boys/001-boy.svg';
import { ReactComponent as Boy2 } from './assets/boys/002-boy.svg';
import { ReactComponent as Boy3 } from './assets/boys/003-boy.svg';
import { ReactComponent as Boy4 } from './assets/boys/004-boy.svg';
import { ReactComponent as Boy5 } from './assets/boys/005-boy.svg';
import { ReactComponent as Boy6 } from './assets/boys/006-boy.svg';
import { ReactComponent as Boy7 } from './assets/boys/007-boy.svg';
import { ReactComponent as Boy8 } from './assets/boys/008-boy.svg';
import { ReactComponent as Boy9 } from './assets/boys/009-boy.svg';
import { ReactComponent as Boy10 } from './assets/boys/010-boy.svg';
import { ReactComponent as Boy11 } from './assets/boys/011-boy.svg';
import { ReactComponent as Boy12 } from './assets/boys/012-boy.svg';
import { ReactComponent as Boy13 } from './assets/boys/013-boy.svg';
import { ReactComponent as Boy14 } from './assets/boys/014-boy.svg';
import { ReactComponent as Boy15 } from './assets/boys/015-boy.svg';
import { ReactComponent as Boy16 } from './assets/boys/016-boy.svg';
import { ReactComponent as Boy17 } from './assets/boys/017-boy.svg';
import { ReactComponent as Boy18 } from './assets/boys/018-boy.svg';
import { ReactComponent as Boy19 } from './assets/boys/019-boy.svg';
import { ReactComponent as Boy20 } from './assets/boys/020-boy.svg';
import { ReactComponent as Boy21 } from './assets/boys/021-boy.svg';
import { ReactComponent as Boy22 } from './assets/boys/022-boy.svg';
import { ReactComponent as Boy23 } from './assets/boys/023-boy.svg';

import { ReactComponent as Girl1 } from './assets/girls/001-girl.svg';
import { ReactComponent as Girl2 } from './assets/girls/002-girl.svg';
import { ReactComponent as Girl3 } from './assets/girls/003-girl.svg';
import { ReactComponent as Girl4 } from './assets/girls/004-girl.svg';
import { ReactComponent as Girl5 } from './assets/girls/005-girl.svg';
import { ReactComponent as Girl6 } from './assets/girls/006-girl.svg';
import { ReactComponent as Girl7 } from './assets/girls/007-girl.svg';
import { ReactComponent as Girl8 } from './assets/girls/008-girl.svg';
import { ReactComponent as Girl9 } from './assets/girls/009-girl.svg';
import { ReactComponent as Girl10 } from './assets/girls/010-girl.svg';
import { ReactComponent as Girl11 } from './assets/girls/011-girl.svg';
import { ReactComponent as Girl12 } from './assets/girls/012-girl.svg';
import { ReactComponent as Girl13 } from './assets/girls/013-girl.svg';
import { ReactComponent as Girl14 } from './assets/girls/014-girl.svg';
import { ReactComponent as Girl15 } from './assets/girls/015-girl.svg';
import { ReactComponent as Girl16 } from './assets/girls/016-girl.svg';
import { ReactComponent as Girl17 } from './assets/girls/017-girl.svg';
import { ReactComponent as Girl18 } from './assets/girls/018-girl.svg';
import { ReactComponent as Girl19 } from './assets/girls/019-girl.svg';
import { ReactComponent as Girl20 } from './assets/girls/020-girl.svg';
import { ReactComponent as Girl21 } from './assets/girls/021-girl.svg';
import { ReactComponent as Girl22 } from './assets/girls/022-girl.svg';
import { ReactComponent as Girl23 } from './assets/girls/023-girl.svg';
import { ReactComponent as Girl24 } from './assets/girls/024-girl.svg';
import { ReactComponent as Girl25 } from './assets/girls/025-girl.svg';
import { ReactComponent as Girl26 } from './assets/girls/026-girl.svg';
import { ReactComponent as Girl27 } from './assets/girls/027-girl.svg';

const avatarMap = {
  'boys/001-boy': Boy1,
  'boys/002-boy': Boy2,
  'boys/003-boy': Boy3,
  'boys/004-boy': Boy4,
  'boys/005-boy': Boy5,
  'boys/006-boy': Boy6,
  'boys/007-boy': Boy7,
  'boys/008-boy': Boy8,
  'boys/009-boy': Boy9,
  'boys/010-boy': Boy10,
  'boys/011-boy': Boy11,
  'boys/012-boy': Boy12,
  'boys/013-boy': Boy13,
  'boys/014-boy': Boy14,
  'boys/015-boy': Boy15,
  'boys/016-boy': Boy16,
  'boys/017-boy': Boy17,
  'boys/018-boy': Boy18,
  'boys/019-boy': Boy19,
  'boys/020-boy': Boy20,
  'boys/021-boy': Boy21,
  'boys/022-boy': Boy22,
  'boys/023-boy': Boy23,
  'girls/001-girl': Girl1,
  'girls/002-girl': Girl2,
  'girls/003-girl': Girl3,
  'girls/004-girl': Girl4,
  'girls/005-girl': Girl5,
  'girls/006-girl': Girl6,
  'girls/007-girl': Girl7,
  'girls/008-girl': Girl8,
  'girls/009-girl': Girl9,
  'girls/010-girl': Girl10,
  'girls/011-girl': Girl11,
  'girls/012-girl': Girl12,
  'girls/013-girl': Girl13,
  'girls/014-girl': Girl14,
  'girls/015-girl': Girl15,
  'girls/016-girl': Girl16,
  'girls/017-girl': Girl17,
  'girls/018-girl': Girl18,
  'girls/019-girl': Girl19,
  'girls/020-girl': Girl20,
  'girls/021-girl': Girl21,
  'girls/022-girl': Girl22,
  'girls/023-girl': Girl23,
  'girls/024-girl': Girl24,
  'girls/025-girl': Girl25,
  'girls/026-girl': Girl26,
  'girls/027-girl': Girl27,
};

export default function getAvatar(fileName: string) {
  if (fileName === 'user') {
    return fileName;
  }
  return avatarMap[fileName] || Boy1;
}
